import React from "react";

const LocationMaps = () => (
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2113.763407950957!2d100.52771476656962!3d13.724721629378251!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29908077f4ad5%3A0x648e3491c5420df4!2zS2FjaGVuIERpZ2l0YWwg4Lia4Lij4Li04Lip4Lix4LiXIOC4hOC5gOC4iuC4meC4l-C4o-C5jCDguJTguLTguIjguLTguJfguLHguKUg4LiI4Liz4LiB4Lix4LiU!5e0!3m2!1sth!2sth!4v1737516672454!5m2!1sth!2sth"
    width="100%"
    height="400"
    style={{
      border: 0,
      borderRadius: "8px",
      minWidth: "400px",
      width: "100%",
      maxWidth: "600px",
    }}
    allowfullscreen=""
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade"
  ></iframe>
);

export default LocationMaps;
